import type {
  OrganizationDto,
  OrganizationOwnerDto,
} from '@/shared/api/modules/contracts';
import type { Organization, OrganizationOwner } from '../model/types';

export const transformOrganizationOwnerDtoToOrganizationOwner = (
  organizationOwnerDto: OrganizationOwnerDto
): OrganizationOwner => {
  return {
    createdAt: organizationOwnerDto.createdAt,
    email: organizationOwnerDto.email,
    fullName: organizationOwnerDto.fullName,
    id: String(organizationOwnerDto.id),
    lastLogin: organizationOwnerDto.lastLogin,
    updatedAt: organizationOwnerDto.updatedAt,
  };
};

export const transformOrganizationDtoToOrganization = (
  organizationDto: OrganizationDto
): Organization => {
  const {
    id,
    address,
    createdAt,
    name,
    ownerId,
    siteUrl,
    updatedAt,
    owner,
    isDemo,
    hideCompSetToggle,
    staffSource,
  } = organizationDto;

  return {
    id: String(id),
    address,
    createdAt,
    name,
    ownerId: String(ownerId),
    siteUrl,
    updatedAt,
    owner: owner
      ? transformOrganizationOwnerDtoToOrganizationOwner(owner)
      : null,
    isDemo,
    hideCompSetToggle,
    staffSource,
  };
};
